import * as angular from "angular";

export interface ICSVParsingOptions {
    ignoreHeaderLine?: boolean;
    ignoreEmptyLines?: boolean;
    normaliseWhitespace?: boolean;
}

// Source http://plnkr.co/edit/y5n16v?p=preview
export class FileReaderService {

    static $inject = ["$q", "$timeout"];

    constructor(
        private $q: angular.IQService,
        private $timeout: angular.ITimeoutService) {
    }

    readAsDataUrl(file: File): angular.IPromise<any> {
        const deferred = this.$q.defer<any>();

        const reader = this.getReader(deferred);
        reader.readAsDataURL(file);

        return deferred.promise;
    }

    readAsText(file: File): angular.IPromise<any> {
        const deferred = this.$q.defer<any>();

        const reader = this.getReader(deferred);
        reader.readAsText(file);

        return deferred.promise;
    }

    readCSV(input: string, options?: ICSVParsingOptions): string[][] {
        const parsedArray: string[][] = [];
        const lines = input.split(/\r?\n|\r/);

        lines.forEach((line, index) => {
            if (index == 0 && options?.ignoreHeaderLine) {
                return;
            }

            if (options?.normaliseWhitespace) {
                line = line.replace(/\s\s+/g, ' ').trim();
            }

            const cells = line.split(",");

            if (options?.ignoreEmptyLines) {
                if (!cells.some(c => c.length > 0)) {
                    return;
                }
            }

            parsedArray.push(cells);
        });

        return parsedArray;
    }

    fileSizeAsString(fileSize: number): string {
        var i = 0;
        var size = fileSize;

        // This always make it into Kb
        while (size > 1024 || i == 0) {
            i++;
            size = size / 1024;
        }

        size = Math.round(size * 100) / 100;

        var sizeLabelArray = ["b", "Kb", "Mb", "Gb"];

        return `${size} ${sizeLabelArray[i]}`;
    }

    fileIsImage(file: File) {
        return file['type'].includes('image');
    }

    // -----------------------------

    private getReader(deferred: angular.IDeferred<any>) {
        const reader = new FileReader();

        reader.onload = () => { deferred.resolve(reader.result); };
        reader.onerror = () => { deferred.reject(reader.result); };
        reader.onprogress = (event) => { deferred.notify(event); };

        return reader;
    };
}
